import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { LayoutDashboard, DollarSign, Users, Package, FileText, Handshake, LogOut, Globe, Settings, BarChart3 } from 'lucide-react';
import { Button } from './ui/button';

export const Sidebar = () => {
  const location = useLocation();
  const { user, logout } = useAuth();
  const { t, toggleLanguage, language } = useLanguage();

  const navItems = [
    { path: '/dashboard', icon: LayoutDashboard, label: t('dashboard') },
    { path: '/finance', icon: DollarSign, label: t('finance') },
    { path: '/inventory', icon: Package, label: t('inventory') },
    { path: '/invoicing', icon: FileText, label: t('invoicing') },
    { path: '/hrm', icon: Users, label: t('hrm') },
    { path: '/outsourcing', icon: Handshake, label: t('outsourcing') },
    { path: '/reports', icon: BarChart3, label: t('reports') },
    ...(user?.role === 'admin' ? [{ path: '/settings', icon: Settings, label: 'Settings' }] : []),
  ];

  return (
    <div className="w-64 min-h-screen bg-primary text-primary-foreground flex flex-col" style={{backgroundImage: 'url("data:image/svg+xml,%3Csvg width="20" height="20" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M0 0h20v20H0z" fill="%230F172A"/%3E%3Cpath d="M0 0h10v10H0z" fill="%23000000" fill-opacity="0.03"/%3E%3C/svg%3E")'}}>
      <div className="p-6 border-b border-slate-700">
        <h1 className="text-2xl font-bold tracking-tight" data-testid="app-title">
          {t('dashboard')}
        </h1>
        <p className="text-xs text-slate-400 mt-1" lang={language === 'ar' ? 'ar' : 'en'}>
          {user?.name} ({user?.role})
        </p>
      </div>

      <nav className="flex-1 p-4 space-y-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname.startsWith(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              data-testid={`nav-${item.path.slice(1)}`}
              className={`flex items-center gap-3 px-4 py-3 rounded-md transition-colors ${
                isActive
                  ? 'bg-accent text-accent-foreground'
                  : 'hover:bg-slate-800 text-slate-300'
              }`}
            >
              <Icon className="w-5 h-5" />
              <span className="text-sm font-medium" lang={language === 'ar' ? 'ar' : 'en'}>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="p-4 border-t border-slate-700 space-y-2">
        <Button
          variant="ghost"
          className="w-full justify-start gap-3 text-slate-300 hover:bg-slate-800"
          onClick={toggleLanguage}
          data-testid="language-toggle-btn"
        >
          <Globe className="w-5 h-5" />
          <span className="text-sm">{language === 'en' ? 'العربية' : 'English'}</span>
        </Button>
        <Button
          variant="ghost"
          className="w-full justify-start gap-3 text-slate-300 hover:bg-slate-800"
          onClick={logout}
          data-testid="logout-btn"
        >
          <LogOut className="w-5 h-5" />
          <span className="text-sm" lang={language === 'ar' ? 'ar' : 'en'}>{t('logout')}</span>
        </Button>
      </div>
    </div>
  );
};